export * from './test';
export function getFactor() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var fn = function fn(str) {
    return str === 'positive' ? -1 : 1;
  };
  return args.reduce(function (acc, cur) {
    return acc * fn(cur);
  }, 1);
}